var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutgoingPhoneIcon = function SvgOutgoingPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m3.666 4.93 1.88-1.88a3.187 3.187 0 0 1 4.507 0l3.457 3.457a3.19 3.19 0 0 1 .676 3.51l-1.512 3.524.118.31a13.1 13.1 0 0 0 7.34 7.352l.327.125 3.528-1.512a3.19 3.19 0 0 1 3.351.529l.158.147 3.455 3.456a3.187 3.187 0 0 1 0 4.507l-1.88 1.88a5.29 5.29 0 0 1-5.419 1.274l-.492-.168a33.64 33.64 0 0 1-20.78-21.13l-.078-.257A5.29 5.29 0 0 1 3.666 4.93m8.342 3.08L8.551 4.552a1.06 1.06 0 0 0-1.503 0l-1.88 1.88a3.15 3.15 0 0 0-.824 3.035l.06.2a31.5 31.5 0 0 0 19.452 19.765l.476.163a3.17 3.17 0 0 0 3.237-.764l1.88-1.88a1.06 1.06 0 0 0 0-1.502l-3.455-3.455a1.06 1.06 0 0 0-1.17-.225l-4.278 1.833-.384-.128a15.24 15.24 0 0 1-9.504-9.26l-.262-.75 1.837-4.286c.171-.4.082-.863-.225-1.17m16.68-1.19v4.867h2.125v-8.5h-8.5v2.125h4.877l-7.753 7.752 1.502 1.503z",
    clipRule: "evenodd"
  })));
};
export default SvgOutgoingPhoneIcon;